import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: true,
    imports: [NgClass, MatIcon]
})
export class FeedbackComponent implements OnInit {
  @Input() sendedMail!: boolean;
  constructor() { }

  ngOnInit() {
  }

}
